import { MediaPlay } from '@carvana/icons';
import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import styles from './Video.module.css';

export const VideoWrapper = createComponent('div', {
  className: cx(
    'relative mb-40 flex flex-col items-center',
    styles.videoWrapper
  )
});

export const Video = createComponent('video', {
  className:
    'relative h-[180px] w-full max-w-[800px] cursor-pointer touch-auto m:h-[300px] l:h-[450px]'
});

export const MiddlePlayButton = createComponent('button', {
  className:
    'pointer-events-none absolute inset-0 m-auto flex h-56 w-56 items-center justify-center rounded-full border-0 bg-white m:h-[90px] m:w-[90px]'
});

export const MediaPlayIcon = createComponent(MediaPlay, {
  className: cx(
    'ml-[2px] flex h-[15px] w-[13px] text-blue-2 m:ml-[5px] m:h-[21px] m:w-[19px]',
    styles.mediaPlayIcon
  )
});
